var _defs, _path, _line, _path2, _line2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourBags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3_Caf\\xE9s_op\\xE7\\xE3o",
    "data-name": " 3 Caf\\xE9s op\\xE7\\xE3o",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.4 95.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #343233;\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        fill: #d83f28;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.1,78.1c8.7,0,15.5-1.2,21.2-2.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 122.9,
    y1: 24,
    x2: 122.9,
    y2: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.7,19.1l-.3-2.5v-.2c0-.3.3-.6.7-.6l47.3-6.6.7,6.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.3,
    y1: 73,
    x2: 118.3,
    y2: 73
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.3,19.1v-2.5h0s0,0,0,0l.3,2.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.8,5.4c0,.3.2.6.4.7h.2v3.1l-47.3,6.7c-.3,0-.6.3-.7.6v-3.5h.2c.3-.3.4-.6.4-.9,0-.3-.2-.6-.4-.6h-.2v-1.4c0-1.4,1-2.6,2.3-2.8L119.1,1c1.1-.2,2.1.6,2.3,1.7,0,.2,0,.3,0,.5v1.3h-.2c-.3.3-.4.6-.5.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-3",
    d: "M98.1,47.2c-.6.8-1,1.8-1,2.9,0,.7.1,1.3.4,1.9.3.6.7,1.1,1.2,1.4.5.4,1.1.7,1.8.9.7.2,1.4.3,2.1.3,1,0,2-.2,2.9-.6.9-.4,1.8-.9,2.5-1.6l-7.3-7.8c-1,.7-1.9,1.5-2.6,2.4M99.9,33.4c-.6.6-1,1.4-1,2.2,0,.3,0,.5.1.8.1.3.2.6.4.8.2.4.5.7.8,1.1.4.4.8.9,1.3,1.5,1-.6,2-1.4,2.9-2.2.7-.6,1.1-1.4,1.1-2.3,0-.8-.3-1.5-.9-2-.6-.5-1.5-.8-2.3-.8-.9,0-1.8.3-2.5.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.5,85.6c-6.7,1.7-13.5,2.6-20.4,2.5-1.5,0-3.1-.1-4.6-.4-2.2-.5-3.6-1.2-4.5-2.2h0c-1.8-2-1.7-5.5-2.7-11.3L2.1,26.7s0,0,0,0v-.2c0-.3.3-.6.7-.6l47.3-6.7.3,3.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,85.5l-6.6-5.6c-1.8-1.9-2.7-4.6-2.4-7.2l1.1-46.1s0,0,0,0l5.2,47.5c.9,5.8.9,9.2,2.7,11.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.5,15.5c0,.3.2.6.4.6h.2v3.1L2.8,25.9c-.3,0-.6.3-.7.6v-3.5l.2-.2c.3-.2.4-.5.4-.8,0-.3-.2-.5-.4-.6h-.2v-1.4c0-1.4,1-2.5,2.3-2.8l43.4-6.1c1.1-.2,2.1.6,2.3,1.7,0,.2,0,.3,0,.5v1.3h-.2c-.3.3-.4.6-.5.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    className: "cls-3",
    d: "M26.9,57.3c-.6.8-1,1.8-1,2.9,0,.7.2,1.3.5,1.9.3.6.7,1.1,1.2,1.4.5.4,1.1.7,1.7.9.7.2,1.4.3,2.2.3,1,0,2-.2,2.9-.6.9-.4,1.8-.9,2.5-1.6l-7.4-7.7c-1,.7-1.9,1.5-2.6,2.4M28.6,43.5c-.6.6-1,1.4-1,2.2,0,.3,0,.5.1.8,0,.3.2.6.4.8.3.4.5.7.8,1.1.4.4.8.9,1.3,1.4,1-.7,2-1.4,2.9-2.2.7-.6,1.1-1.4,1.1-2.3,0-.8-.3-1.5-.9-2-.6-.5-1.5-.8-2.3-.8-.9,0-1.8.3-2.5.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.1,74.8l-.2,6.8c0,2.6-1.5,5-3.8,6.3-.6.3-1.1.6-1.6.9-7.4,3.3-16.3,5.8-29.7,5.8-1.5,0-3-.1-4.5-.4-2.3-.5-3.7-1.2-4.6-2.2h0c-1.4-1.6-1.7-4.1-2.2-8-.1-1-.3-2.1-.5-3.3l-5.3-47.5h0v-.2c0-.3.3-.6.7-.6l11.7-1.7,35.7-5,3.9,39.2c.3,3.3.5,6.6.4,9.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.8,91.9h0l-6.6-5.5c-.2-.3-.5-.5-.7-.8-1.4-1.8-2-4.1-1.7-6.4l1.1-46h0s0,0,0,0l5.2,47.5c.2,1.2.3,2.3.5,3.3.5,3.8.8,6.3,2.2,8Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.3,21.9c0,.3.2.5.4.7h.2v3.1l-35.7,5-11.7,1.6c-.3,0-.6.3-.7.6v-3.5h.2c.3-.3.4-.6.4-.9,0-.3-.2-.5-.4-.6h-.2v-1.4c0-1.4,1-2.5,2.3-2.8l9.2-1.3,34.2-4.8c1.1-.2,2.1.6,2.3,1.7,0,.2,0,.3,0,.5v1.3h-.2c-.3.3-.4.6-.4.9Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    className: "cls-3",
    d: "M63.6,63.8c-.6.8-1,1.8-1,2.9,0,.7.1,1.3.4,1.9.3.6.7,1,1.3,1.4.5.4,1.1.7,1.8.9.7.2,1.4.3,2.1.3,1,0,2-.2,2.9-.6.9-.4,1.8-.9,2.5-1.6l-7.3-7.8c-1,.7-1.9,1.5-2.6,2.5M65.3,49.9c-.6.6-1,1.4-1,2.2,0,.3,0,.5.1.8.1.3.2.6.4.8.3.4.5.7.8,1.1.4.4.8.9,1.3,1.4,1-.7,2-1.4,2.9-2.2.7-.6,1.1-1.4,1.1-2.3,0-.8-.3-1.5-.9-2-.6-.5-1.5-.8-2.3-.8-.9,0-1.8.3-2.5.9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.4,67.8l-.2,6.8c0,2.6-1.5,5-3.8,6.3-.6.3-1.1.6-1.6.9-7.4,3.3-16.3,5.8-29.7,5.8-1.5,0-3-.1-4.5-.4-2.3-.5-3.7-1.2-4.6-2.2h0c-1.4-1.6-1.7-4.1-2.2-8-.1-1-.3-2.1-.5-3.3l-5.3-47.5h0v-.2c0-.3.3-.6.7-.6l11.7-1.7,35.7-5,3.9,39.2c.3,3.3.5,6.6.4,9.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121,84.9h0l-6.6-5.5c-.2-.3-.5-.5-.7-.8-1.4-1.8-2-4.1-1.7-6.4l1.1-46h0s0,0,0,0l5.2,47.5c.2,1.2.3,2.3.5,3.3.5,3.8.8,6.3,2.2,8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.5,14.9c0,.3.2.5.4.7h.2v3.1l-35.7,5-11.7,1.6c-.3,0-.6.3-.7.6v-3.5h.2c.3-.3.4-.6.4-.9,0-.3-.2-.5-.4-.6h-.2v-1.4c0-1.4,1-2.5,2.3-2.8l9.2-1.3,34.2-4.8c1.1-.2,2.1.6,2.3,1.7,0,.2,0,.3,0,.5v1.3h-.2c-.3.3-.4.6-.4.9Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3-2",
    "data-name": "SVGID-3",
    className: "cls-3",
    d: "M137.9,56.8c-.6.8-1,1.8-1,2.9,0,.7.1,1.3.4,1.9.3.6.7,1,1.3,1.4.5.4,1.1.7,1.8.9.7.2,1.4.3,2.1.3,1,0,2-.2,2.9-.6.9-.4,1.8-.9,2.5-1.6l-7.3-7.8c-1,.7-1.9,1.5-2.6,2.5h0ZM139.6,42.9c-.6.6-1,1.4-1,2.2,0,.3,0,.5.1.8.1.3.2.6.4.8.3.4.5.7.8,1.1.4.4.8.9,1.3,1.4,1-.7,2-1.4,2.9-2.2.7-.6,1.1-1.4,1.1-2.3,0-.8-.3-1.5-.9-2-.6-.5-1.5-.8-2.3-.8-.9,0-1.8.3-2.5.9h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourBags);
export default __webpack_public_path__ + "static/media/four-bags.826e165b29a3fbfacaa440be0464975b.svg";
export { ForwardRef as ReactComponent };